import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";

const PrivacyModal = ({ isOpen, onOpenChange }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl bg-industrial-900 border-white/10 text-slate-200 p-0 overflow-hidden">
                <DialogHeader className="p-6 pb-0">
                    <DialogTitle className="text-2xl font-bold text-white">Informativa sulla Privacy</DialogTitle>
                    <DialogDescription className="text-slate-400">
                        Ai sensi del Regolamento (UE) 2016/679 (GDPR)
                    </DialogDescription>
                </DialogHeader>
                <div className="p-6">
                    <ScrollArea className="h-[60vh] pr-4">
                        <div className="space-y-6 text-sm text-slate-300 leading-relaxed">
                            <section>
                                <h4 className="text-white font-bold mb-2">1. Titolare del Trattamento</h4>
                                <p>
                                    Il Titolare del trattamento è <strong>Tecno Domus 360 di De Cupis Roberto</strong>, con sede in Roma e Provincia.
                                    Per qualsiasi questione relativa alla privacy, puoi contattarci all'indirizzo email: <strong>info@tecnodomus360.it</strong>.
                                </p>
                            </section>

                            <section>
                                <h4 className="text-white font-bold mb-2">2. Dati Raccolti</h4>
                                <p>
                                    Attraverso il modulo di contatto o tramite i cookie tecnici, raccogliamo i seguenti dati:
                                </p>
                                <ul className="list-disc pl-5 mt-2 space-y-1">
                                    <li>Dati identificativi (Nome e Cognome)</li>
                                    <li>Dati di contatto (Email, Numero di telefono)</li>
                                    <li>Contenuto del messaggio inviato</li>
                                    <li>Dati di navigazione tecnici (tramite cookie necessari)</li>
                                </ul>
                            </section>

                            <section>
                                <h4 className="text-white font-bold mb-2">3. Finalità del Trattamento</h4>
                                <p>
                                    I tuoi dati vengono trattati esclusivamente per:
                                </p>
                                <ul className="list-disc pl-5 mt-2 space-y-1">
                                    <li>Rispondere alle tue richieste di informazioni o preventivi.</li>
                                    <li>Garantire il corretto funzionamento tecnico del sito web.</li>
                                    <li>Adempiere ad obblighi di legge.</li>
                                </ul>
                                <p className="mt-2">
                                    Non utilizziamo i tuoi dati per finalità di marketing automatizzato né li cediamo a terzi per scopi commerciali.
                                </p>
                            </section>

                            <section>
                                <h4 className="text-white font-bold mb-2">4. Base Giuridica</h4>
                                <p>
                                    Il trattamento dei dati per la gestione delle richieste si basa sull'esecuzione di misure precontrattuali adottate su tua richiesta e sul tuo esplicito consenso fornito tramite il checkbox nel modulo.
                                </p>
                            </section>

                            <section>
                                <h4 className="text-white font-bold mb-2">5. Conservazione dei Dati</h4>
                                <p>
                                    I dati saranno conservati per il tempo strettamente necessario all'evasione della tua richiesta, a meno che non si instauri un rapporto contrattuale o siano necessari per obblighi di legge (es. fatturazione).
                                </p>
                            </section>

                            <section>
                                <h4 className="text-white font-bold mb-2">6. Diritti dell'Interessato</h4>
                                <p>
                                    Hai il diritto di richiedere in qualsiasi momento:
                                </p>
                                <ul className="list-disc pl-5 mt-2 space-y-1">
                                    <li>L'accesso ai tuoi dati personali.</li>
                                    <li>La rettifica o la cancellazione degli stessi.</li>
                                    <li>La limitazione del trattamento.</li>
                                    <li>Di opporti al trattamento.</li>
                                    <li>La portabilità dei dati.</li>
                                </ul>
                                <p className="mt-2">
                                    Puoi esercitare i tuoi diritti scrivendo a <strong>info@tecnodomus360.it</strong>. Hai inoltre il diritto di proporre reclamo al Garante per la Protezione dei Dati Personali.
                                </p>
                            </section>

                            <section>
                                <h4 className="text-white font-bold mb-2">7. Sicurezza</h4>
                                <p>
                                    Adottiamo misure di sicurezza tecniche e organizzative adeguate per proteggere i tuoi dati da accessi non autorizzati, distruzioni accidentali o perdite.
                                </p>
                            </section>
                        </div>
                    </ScrollArea>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default PrivacyModal;
